import React, { useState } from 'react';
import axios from 'axios';
import './style/Contact.css';
import Footer from '../components/Footer';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const baseUrl = process.env.REACT_APP_API_URL;
const endpointPost = `${baseUrl}/contact-email`;

function Contact() {
  const { t } = useTranslation(); // Initialize the translation function
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: '',
    agree: false
  });

  const [submitting, setSubmitting] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    const transformedPayload = {
      name: formData.name,
      email: formData.email,
      company: formData.company,
      phone: formData.phone,
      message: formData.message,
      agree: formData.agree
    };

    try {
      const response = await axios.post(endpointPost, JSON.stringify(transformedPayload), {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.statusCode >= 400) {
        throw new Error(response.data.message || t('contact.errors.sendError'));
      }

      setSucceeded(true);
    } catch (err) {
      setError(err.message || t('contact.errors.genericError'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t('contact.helmet.title')}</title>
        <meta name="description" content={t('contact.helmet.description')} />
        <meta name="keywords" content={t('contact.helmet.keywords')} />
        <meta property="og:title" content={t('contact.helmet.ogTitle')} />
        <meta property="og:description" content={t('contact.helmet.ogDescription')} />
        <meta property="og:url" content="https://www.beonwall.com/contact" />
        <meta property="og:image" content="https://www.beonwall.com/assets/logobeonwall.png" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <div className="upload-page">
        <h2 className="contact-heading">{t('contact.heading')}</h2>
        <div className="upload-page-container">
          <h2 className="contact-title">{t('contact.title')}</h2>

          {succeeded ? (
            <p className="contact-success">✅ {t('contact.successMessage')}</p>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <label>
                {t('contact.form.nameLabel')}<span className="required">*</span>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                {t('contact.form.emailLabel')}<span className="required">*</span>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                {t('contact.form.companyLabel')}
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </label>

              <label>
                {t('contact.form.phoneLabel')}
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </label>

              <label>
                {t('contact.form.messageLabel')}<span className="required">*</span>
                <textarea
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </label>

              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={formData.agree}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="agree">{t('contact.form.agreeLabel')}</label>
              </div>

              {error && <p className="contact-error">❌ {error}</p>}

              <button type="submit" className="btn-gold" disabled={submitting}>
                {submitting ? t('contact.form.sendingButton') : t('contact.form.sendButton')}
              </button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Contact;